<template>
    <zen-slide-in
        :isOpen="isOpen"
        :title="'Grants: ' + (teamName ?? '')"
        @close="$emit('close')"
    >
        <template #body>
            <div class="space-y-6">
                <p class="text-sm text-taupe-500">
                    These grants are assigned to this team and apply to all team
                    members.
                </p>
                <div>
                    <div class="flex items-center justify-between mb-3">
                        <h3 class="text-sm font-medium text-taupe-900">
                            Team grants
                        </h3>
                        <zen-button
                            variant="tertiary"
                            size="small"
                            @click="$emit('add-grant')"
                            data-testid="add-grant-button"
                        >
                            Add Grant
                        </zen-button>
                    </div>
                    <ul
                        v-if="grants.length > 0"
                        class="divide-y divide-taupe-100"
                    >
                        <li
                            v-for="grant in grants"
                            :key="grant.ulid"
                            class="flex items-center justify-between py-2"
                            :data-testid="'grant-row-' + grant.ulid"
                        >
                            <div class="flex items-center gap-2">
                                <zen-inline-pill :value="grant.role" />
                                <span class="text-sm text-taupe-600"
                                    >@ {{ scopeLabel(grant) }}</span
                                >
                            </div>
                            <button
                                @click="$emit('revoke-grant', grant)"
                                class="text-taupe-400 hover:text-red-500 transition-colors"
                                title="Revoke grant"
                                :data-testid="'revoke-grant-' + grant.ulid"
                            >
                                <svg
                                    class="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </button>
                        </li>
                    </ul>
                    <p v-else class="text-sm text-taupe-400">
                        No grants assigned.
                    </p>
                </div>
            </div>
        </template>
        <template v-slot:buttons>
            <zen-button
                variant="secondary"
                size="medium"
                @click="$emit('close')"
            >
                Close
            </zen-button>
        </template>
    </zen-slide-in>
</template>

<script>
export default {
    name: 'ManageTeamGrantsSlideIn',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        teamName: {
            type: String,
            default: '',
        },
        grants: {
            type: Array,
            required: true,
        },
        scopeLabel: {
            type: Function,
            required: true,
        },
    },
    emits: ['close', 'add-grant', 'revoke-grant'],
}
</script>
